import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type IIroStandardsAdminSlice from './interfaces/IIroStandardsAdminSlice';

export const initialState: IIroStandardsAdminSlice = {
  loading: false,
};

export const iroStandardsAdminSlice = createSlice({
  name: 'iroStandardsAdmin',
  initialState,
  reducers: {
    setLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    resetState: () => initialState,
  },
});

export const { setLoading, resetState } = iroStandardsAdminSlice.actions;

export default iroStandardsAdminSlice.reducer;
